export default [
  {
    name: 'APP_LOGOUT',
    callback: function (e) {
      this.$store.set('user/info', null)
      this.$store.set('user/token', null)
      this.$cookies.remove('user')
      // this.snackbar = {
      //   show: true,
      //   color: 'green',
      //   text: 'Session expired.'
      // }
      this.$router.replace({ path: '/' })
      // this.$message.error('Token has expired')
    },
  },
  {
    name: 'APP_GO_PROFILE',
    callback: function (e) {
      this.$router.replace({ path: '/components/profile/' })
    },
  },
  {
    name: 'APP_SNACK_BAR',
    callback: function (text, color, type) {
      this.snackbar = {
        show: true,
        color: color,
        text: text,
        type: type,
      }
    },
  },
]
